import { flow, get, groupBy, map, mapValues, sortBy } from 'lodash/fp';

import decodeCompetitor from './decodeCompetitor';
import decodePlayer from './decodePlayer';
import decodeTeam from './decodeTeam';

const mapPlayers = flow(
  get('selection.players'),
  sortBy('gameOrder'),
  groupBy('position.key'),
  mapValues(map(decodePlayer))
);

const mapTeams = flow(get('selection.teams'), map(decodeTeam));

function decodeEntry(data = {}, games = []) {
  const players = (get('selection.players', data) || []).map(p => ({
    position: { key: 'dummy' },
    gameOrder: (games.findIndex(g => g.id === get('game.id', p)) || 0) + 1,
    ...p
  }));
  const selection = { ...data.selection, players };
  const newData = { ...data, selection };
  return {
    ...decodeCompetitor(newData),
    playersSubmitted: mapPlayers(newData),
    teamsSubmitted: mapTeams(newData)
  };
}

export default decodeEntry;
